import { shape, func } from 'prop-types';

export const WithRouterShape = {
  location: shape({}).isRequired,
  navigate: func.isRequired,
  params: shape({}).isRequired,
};
